import React                            from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import PjaxWrapper                      from '../utils/PjaxWrapper';
import TopLiveCamGirlsBlock             from "../components/Homepage/Block/TopLiveCamGirlsBlock";
import "../../../src/VX/Asset/Less/VX/View/Plain.less";

export function run(pmJsom) {
	const pm = JSON.parse(pmJsom);
	const el = document.getElementById('notfound-camsblock');

	render(
		<TopLiveCamGirlsBlock
			tileGridConfig={pm.topCams.tiles}
			tileGridTotal={pm.topCams.total}
			link={pm.topCams.link}
			showHighlightGrid={false}
		/>,
		el
	);
	PjaxWrapper.addUnloadFunc(() => unmountComponentAtNode(el));
}

